import { render, staticRenderFns } from "./token.vue?vue&type=template&id=f3c18744&scoped=true"
import script from "./token.vue?vue&type=script&lang=js"
export * from "./token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c18744",
  null
  
)

export default component.exports